/**
 * /app/$tenantSlug/settings/coa — old Settings → Chart of accounts page
 * (it only linked out). The chart lives at Books → Masters → Chart of
 * Accounts, so this URL redirects there.
 */

import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_authgated/app/$tenantSlug/settings/coa",
)({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/app/$tenantSlug/accounting/accounts",
      params: { tenantSlug: params.tenantSlug },
      replace: true,
    });
  },
});
